import { FormLabel } from 'react-bootstrap';
import { Field, useField } from 'formik';
import PropTypes from 'prop-types';
import FormErrorMessage from './FormErrorMessage';

function FormInput({ label, name, id }) {
  const [field] = useField(name);

  return (
    <>
      <FormLabel style={{ paddingTop: '1rem' }} htmlFor={id}>
        {label}
      </FormLabel>
      <Field id={id} {...field} style={{ width: '100%' }} />
      <FormErrorMessage name={name} />
    </>
  );
}

FormInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
};

export default FormInput;
